import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

const prefix = '/api/admin/consultant';

export const getConsultantDashboard = async () => {
    try {
        return await apiService.GET(`${prefix}/dashboard`);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/dashboard`, 'GET');
    }
};

export const getConsultantBookings = async (params) => {
    try {
        return await apiService.GET(`${prefix}/bookings`, params);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/bookings`, 'GET');
    }
};

export const getConsultantClients = async (params) => {
    try {
        return await apiService.GET(`${prefix}/clients`, params);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/clients`, 'GET');
    }
};

export const getConsultantClient = async (userId, params = {}) => {
    try {
        return await apiService.GET(`${prefix}/clients/${userId}`, params);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/clients/${userId}`, 'GET');
    }
};

export const getConsultantClientVersion = async (userId, balanceSheetId) => {
    try {
        return await apiService.GET(
            `${prefix}/clients/${userId}/versions/${balanceSheetId}/summary`
        );
    } catch (error) {
        throw handleHttpError(
            error,
            `${prefix}/clients/${userId}/versions/${balanceSheetId}/summary`,
            'GET'
        );
    }
};

export const createConsultantClientVersion = async (userId, payload) => {
    try {
        return await apiService.POST(`${prefix}/clients/${userId}/versions`, payload);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/clients/${userId}/versions`, 'POST');
    }
};

export const getConsultationWorkspace = async (consultationId) => {
    try {
        return await apiService.GET(`${prefix}/consultations/${consultationId}/workspace`);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/consultations/${consultationId}/workspace`, 'GET');
    }
};
export const getConclusionByVersion = (versionId, consultationId) => apiService.GET(
    `/api/admin/balance/version/${versionId}/conclusion`,
    consultationId ? { consultation_id: consultationId } : {}
);
export const submitConsultationVersion = async (consultationId, versionId) => {
    try {
        return await apiService.POST(`${prefix}/consultations/${consultationId}/versions/${versionId}/submit`);
    } catch (error) {
        throw handleHttpError(error, `${prefix}/consultations/${consultationId}/versions/${versionId}/submit`, 'POST');
    }
};

export const completeConsultationBooking = async (consultationId, payload) => {
    try {
        return await apiService.POST(`${prefix}/bookings/${consultationId}/complete`, payload);
    } catch (error) {
        throw handleHttpError(
            error,
            `${prefix}/bookings/${consultationId}/complete`,
            'POST'
        );
    }
};

export const noShowConsultationBooking = async (consultationId, payload) => {
    try {
        return await apiService.POST(`${prefix}/bookings/${consultationId}/no-show`, payload);
    } catch (error) {
        throw handleHttpError(
            error,
            `${prefix}/bookings/${consultationId}/no-show`,
            'POST'
        );
    }
};
